// extracted by mini-css-extract-plugin
export default {"button":"styles_button__ome77","grayFilled":"styles_grayFilled__UipCf","whiteFilled":"styles_whiteFilled__FklcU","blackFilled":"styles_blackFilled__+-OFv"};